export function RemoveNullableProps<T>(obj: T): Partial<T> {
  Object.entries(obj).forEach(([key, val]) => {
    if (val == null) {
      delete obj[key];
    }
  });
  return obj;
}

export function IsObjectsEqual(o1: Object, o2: Object): boolean {
  if (!o1 || !o2) {
    return false;
  }
  const entries1 = Object.entries(o1);
  const entries2 = Object.entries(o2);
  if (entries1.length !== entries2.length) {
    return false;
  }
  function isEqual(v1, v2) {
    return v1 == v2;
  }
  return entries1.every(([key, val1]) => {
    const val2 = o2[key];
    const type = typeof val1;
    if (val1 == null && val2 == null) {
      return true;
    }
    if (['boolean', 'number', 'string'].includes(type)) {
      return isEqual(val1, val2);
    }
    if (val1 instanceof Date) {
      return isEqual(val1.valueOf(), val2.valueOf());
    } else if (type === 'object') {
      return IsObjectsEqual(val1, val2);
    }
    // eslint-disable-next-line no-console
    console.error(`IsObjectsEqual found unsuported propery type ${val1} in object`, o1);
    return false;
  });
}

export function OmitProps<T>(obj: T, properties: string[]): Partial<T> {
  const newObject = {
    ...obj,
  };
  properties.forEach(([key, val]) => delete newObject[key]);
  return newObject;
}
